import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=35044c9a&scoped=true"
import script from "@/views/Users/Specialist/CreateDialog.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Specialist/CreateDialog.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Specialist/create-dialog.scss?vue&type=style&index=0&id=35044c9a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35044c9a",
  null
  
)

export default component.exports